import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, skip } from 'rxjs/operators';
import { selectable } from '../../../../../@core/types/selectable.type';
import { removeSearchRuleByField } from '../../../../../@core/utils/search-input-helper';
import { StringDotToObject } from '../../../../../@core/utils/string-dot-notation-to-object';
import { OpenStockView, Operator, SearchInput, StockTransactionInput, StorageType } from '../../../../../generated/generated-types';
import { OpenStockViewService } from '../../../../warehouse/services/open-stock-view.service';

export interface osvChange {
  osv: OpenStockView,
  quantity: number
}

@Component({
  selector: 'app-mobile-open-stock-chooser',
  templateUrl: './mobile-open-stock-chooser.component.html',
  styleUrls: ['./mobile-open-stock-chooser.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TooltipModule,
  ]
})
export class MobileOpenStockChooserComponent extends FieldType implements OnInit {

  openStockItems: selectable<OpenStockView[]> = [];

  currentSearchInput = new BehaviorSubject<SearchInput>({});
  takeOverQuantityChanged$ = new Subject<osvChange>();

  loading = false;

  constructor(
    private openStockService: OpenStockViewService
  ) {
    super();

    this.takeOverQuantityChanged$.pipe(
      debounceTime(600),
      distinctUntilChanged())
      .subscribe(x => {
        this.takeoverQuantityChanged(x.osv, x.quantity)
      });

    this.currentSearchInput.pipe(
      // distinctUntilChanged((a, b) => {
      //   let compare = JSON.stringify(a.searchFilter.rules) === JSON.stringify(b.searchFilter.rules);
      //   return compare;
      // }), //dirty quickhack
      debounceTime(500),
      skip(1)
    ).subscribe(x => {
      this.loadOpenStock();
    });

  }

  ngOnInit() {
    this.form.valueChanges.subscribe(x => {

      if (this.props.attributes) {
        this.setFilter();
      }
    });
  }

  async setFilter() {

    let currentSi = this.currentSearchInput.value;
    let originalSiJson = JSON.stringify(currentSi);

    let productId = null;
    let storagePlaceId = null;
    let lotNumber = null;

    if (this.props.attributes.productId)
      productId = StringDotToObject(this.model, this.props.attributes.productId);

    if (this.props.attributes.storagePlaceId)
      storagePlaceId = StringDotToObject(this.model, this.props.attributes.storagePlaceId);

    if (this.props.attributes.lotNumber)
      lotNumber = StringDotToObject(this.model, this.props.attributes.lotNumber);

    if (productId) {
      this.openStockService.applySearchRule(currentSi, {
        field: "productId",
        operator: Operator.equal,
        value: productId
      });
    }
    else
      removeSearchRuleByField(currentSi, "productId");

    if (storagePlaceId) {
      removeSearchRuleByField(currentSi, "storageType");
      this.openStockService.applySearchRule(currentSi, {
        field: "storagePlaceId",
        operator: Operator.equal,
        value: storagePlaceId
      });
    }
    else {
      removeSearchRuleByField(currentSi, "storagePlaceId");
      this.openStockService.applySearchRule(currentSi, {
        field: "storageType",
        operator: Operator.equal,
        value: StorageType.STANDARD
      });
    }

    if (lotNumber) {
      this.openStockService.applySearchRule(currentSi, {
        field: "lotNumber",
        operator: Operator.equal,
        value: lotNumber
      });
    }
    else
      removeSearchRuleByField(currentSi, "lotNumber");

    let same = JSON.stringify(currentSi) === originalSiJson;

    if (!same)
      this.currentSearchInput.next(currentSi);
  }

  async loadOpenStock() {
    // this.openStockService.applySearchRule(si, {
    //   field: "storageType",
    //   operator: Operator.notequal,
    //   value: StorageType.QUARANTINE
    // });


    // si.group = ["productId"]

    //todo lot and batch

    this.loading = true;
    this.openStockItems = [];
    let res = await this.openStockService.getItems(this.currentSearchInput.value);
    let items = (await res.mapSingle(x => x.getOpenStockView).toPromise()).items;

    this.openStockItems = items as OpenStockView[];
    this.loading = false;
  }

  takeoverQuantityChanged(osv: OpenStockView, e: number) {
    let allStockTransactions = this.field.formControl.value as StockTransactionInput[];

    if (this.field.formControl.value == null) {
      allStockTransactions = [];
    }

    let existingTrans = allStockTransactions.find(
      x => x.productId == osv.productId &&
        x.lotNumber == osv.lotNumber &&
        x.originStoragePlaceId == osv.storagePlaceId &&
        x.value == osv.value
    );

    if (existingTrans == null) {
      let transInput: StockTransactionInput = {
        productId: osv.productId,
        lotNumber: osv.lotNumber,
        originStoragePlaceId: osv.storagePlaceId,
        value: osv.value,
        quantity: e
      };
      allStockTransactions = [...allStockTransactions, transInput]
      // allStockTransactions.push(transInput);
    }
    else {
      existingTrans.quantity = e;
    }


    this.field.formControl.setValue(allStockTransactions);
    // this.field.formControl.markAsDirty();

  }
}
